import '../../common_screen/my_result_contest_list/index.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRouteObjByGame } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import { useLink } from 'react-router-stack';
import React from 'react';
import { isSmartPhone } from '../../../utilities/helper';
import MyContestListMWeb from './index_mWeb';
import MyContestListWeb from './index_web';

interface Props {
  onPressChangeTab?: any;
}

const MyContestList = ({ onPressChangeTab }: Props) => {
  const dispatch = useDispatch();
  const navigate = useLink();
  const { gameType, item: matchItem, fantasyMatchClick } = useGame();

  const [matchTeamScore, setMatchTeamScore] = useState(0);

  const [error, setError] = useState(false);
  const { myContestList, myTeamList } = useSelector((state: any) => state.fantasy_yes_no);

  const { joined = false, tabType = 'FIXTURE', verified = false } = matchItem;

  const [challenges, setChallenges] = useState([] as any);

  useEffect(() => {
    getMyJoinedContestAPI();
    getMyScore();
  }, []);

  const getMyScore = () => {
    const result = [...myTeamList[matchItem._id]];
    if (result.length > 0) setMatchTeamScore(result[0].score);
  };

  const getMyJoinedContestAPI = async (skip = 0) => {
    const result: any = [...myContestList[matchItem._id]];
    if (!error && result) {
      if (skip === 0) {
        setChallenges(result);
      } else {
        setChallenges((challenges: any): any[] => [...challenges, ...result]);
      }
      setError(false);
    } else {
      setError(true);
    }
  };

  const onPressCard = (contest: any, completed = false) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          contest,
          completed,
          joined,
          tabType
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['contest_details']);
  };

  const onPressJoinContest = () => {
    onPressChangeTab(0);
  };

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onRefresh = async () => {
    await getMyJoinedContestAPI();
    getMyScore();
  };

  const { teamA, teamB, status } = matchItem;

  return (
    <React.Fragment>
      {isSmartPhone ? (
        <MyContestListMWeb
          gameType={gameType}
          matchItem={matchItem}
          onPressBack={onPressBack}
          onPressCard={onPressCard}
          onPressJoinContest={onPressJoinContest}
          teamA={teamA}
          teamB={teamB}
          verified={verified}
          challenges={challenges}
          matchTeamScore={matchTeamScore}
          tabType={tabType}
          onRefresh={onRefresh}
          status={status}
        />
      ) : (
        <MyContestListWeb
          gameType={gameType}
          matchItem={matchItem}
          onPressBack={onPressBack}
          onPressCard={onPressCard}
          onPressJoinContest={onPressJoinContest}
          teamA={teamA}
          teamB={teamB}
          verified={verified}
          challenges={challenges}
          matchTeamScore={matchTeamScore}
          status={status}
        />
      )}
    </React.Fragment>
  );
};

export default React.memo(MyContestList);
